<template>
  <div>
    <template v-for="horse in mergedHorses">
      <div
        v-if="horse.isNonReference && horse.horseName"
        :key="horse.id + '-non-reference'"
      >
        {{ horse.horseName }}
      </div>
      <AppHorseSlot
        v-else-if="horse.isHorseSlot"
        v-bind="horseSlotProps"
        :key="horse.id"
      />

      <component
        :is="componentName"
        v-else
        :key="horse.id"
        :horse="horse"
        v-bind="[attrs, componentProps]"
      >
        <template #showVaccinations>
          <slot name="showVaccinations" :horse="horse" />
        </template>
        <template #horseNameAdditionalDetails="{ horse: h }">
          <slot name="horseNameAdditionalDetails" :horse="h" />
        </template>
        <template #appendHorseDetails="{ horse: h }">
          <slot name="appendHorseDetails" :horse="h" />
        </template>
      </component>
    </template>
  </div>
</template>
<script>
import gql from "fraql";
import AppShowHorseName from "@AppShows/horse/AppShowHorseName.vue";
import AppShowHorseWithDetails from "@AppShows/horse/AppShowHorseWithDetails.vue";
import AppHorseSlot from "@elements/AppHorseSlot.vue";
import HorseRegistrationMerge, {
  RegistrationHorseFragment
} from "@composables/HorseRegistrationMerge.ts";

export default {
  name: "AppShowRegistrationHorses",
  components: { AppShowHorseName, AppShowHorseWithDetails, AppHorseSlot },
  props: {
    componentName: {
      type: String,
      required: true,
      validate(val) {
        return ["AppShowHorseName", "AppShowHorseWithDetails"].includes(val);
      }
    },
    horses: {
      type: Array,
      required: true
    },
    registrationHorses: {
      type: Array,
      required: true
    },
    attrs: {
      type: Object,
      default: null
    },
    horseSlotProps: {
      type: Object,
      default: undefined
    },
    componentProps: {
      type: Object,
      default: null
    }
  },
  computed: {
    mergedHorses() {
      return HorseRegistrationMerge(this.horses, this.registrationHorses);
    }
  },
  fragments: {
    horse: gql`
      fragment _ on Horse {
        ${AppShowHorseWithDetails.fragments.horse}
        ${AppHorseSlot.fragments.horseFields}
      }
    `,
    horseName: gql`
      fragment _ on Horse {
        ${AppShowHorseName.fragments.horse}
        ${AppHorseSlot.fragments.horseFields}
      }
    `,
    registrationHorse: gql`
      fragment _ on RegistrationHorse {
        id
        horseId
        horseName
        horsePonyType
        horseType
        ${RegistrationHorseFragment}
        ${AppHorseSlot.fragments.registrationHorseFields}
      }
    `
  }
};
</script>
